/**
 * @generated SignedSource<<6ec17b8a5cf095b5a2f4b9c59f5f9f40>>
 * @relayHash 912cc6c81e393dc0212fc16c43c2834a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aadf7a40b5c8c72e15b65d17888b6375d2397645bde15a38cf1bf265e04a38be

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "aadf7a40b5c8c72e15b65d17888b6375d2397645bde15a38cf1bf265e04a38be",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
